import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBmswB92YoCadCMvXvlLw4_P_k7tEwiwk8",
  authDomain: "biscornue-card-design.firebaseapp.com",
  projectId: "biscornue-card-design",
  storageBucket: "biscornue-card-design.firebasestorage.app",
  messagingSenderId: "827433294421",
  appId: "1:827433294421:web:ddba47591aa157fb4992dc"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
